import { FormControl, FormField, FormItem, FormLabel, FormMessage } from '@cobliteam/ui/form';
import InputMask from '@cobliteam/ui/form/InputMask';

const DriverCPFInput = () => {
  return (
    <FormField name='cpf'>
      {({ field }) => {
        return (
          <FormItem className='w-full space-y-1'>
            <FormLabel>CPF</FormLabel>
            <FormControl>
              <InputMask name='cpf' mask='___.___.___-__' replacement={{ _: /\d/ }} onChange={field.onChange} value={field.value || ''} placeholder='Nº do CPF' />
            </FormControl>
            <FormMessage />
          </FormItem>
        );
      }}
    </FormField>
  );
};

export default DriverCPFInput;
